import React from "react";
import { Pagination, Drawer, Spin, Table, Tag } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { useNavigate } from "react-router-dom";
import TabSearch from "../../NewComponent/TabSearch/tabSearch";
import { SyncOutlined } from "@ant-design/icons";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
import { ticketReadUnread, ticketReadUnread2 } from "../../API/api";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExtraFilters from "./ExtraFilters";
import { CloseCircleOutlined } from "@ant-design/icons";

export default function TicketTable() {
  const emailState = useSelector((state) => state.emailTicket);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);

  const {
    ET_UPDATE_REFRESH,
    ET_UPDATE_SEARCH,
    ET_UPDATE_PAGE_NO,
    ET_UPDATE_SORT,
    ET_UPDATE_Bulk_REFRESH,
  } = bindActionCreators(Actions, dispatch);

  const onChangetab = (e) => {
    setSelectedRowKeys([]);
    ET_UPDATE_SEARCH(e.target.value);
  };
  const onChangePage = (page) => {
    setSelectedRowKeys([]);
    ET_UPDATE_PAGE_NO(page);
  };

  const toggleReadUnread = () => {
    if (selectedRowKeys.length > 0) {
      const ticketIds = selectedRowKeys;
      ticketReadUnread(ticketIds)
        .then((res) => {
          console.log("Tickets updated successfully:", res);
          // Optionally, you can refresh the ticket data after updating
          ET_UPDATE_REFRESH();
        })
        .catch((err) => {
          console.error("Error updating tickets:", err);
        });
    } else {
      console.warn("No tickets selected to toggle read/unread status.");
    }
  };
  const toggleReadUnread2 = () => {
    if (selectedRowKeys.length > 0) {
      const ticketIds = selectedRowKeys;
      ticketReadUnread2(ticketIds)
        .then((res) => {
          console.log("Tickets updated successfully:", res);
          // Optionally, you can refresh the ticket data after updating
          ET_UPDATE_REFRESH();
        })
        .catch((err) => {
          console.error("Error updating tickets:", err);
        });
    } else {
      console.warn("No tickets selected to toggle read/unread status.");
    }
  };
  const onChangeSort = () => {
    setSelectedRowKeys([]);
    ET_UPDATE_SORT(emailState.sort === "desc" ? "asc" : "desc");
  };
  const onChangeRefresh = () => {
    setSelectedRowKeys([]);
    ET_UPDATE_REFRESH();
  };
  const tabSearch = () => {
    return (
      <TabSearch
        size="medium"
        val={emailState.search}
        onChangeFunc={onChangetab}
        width="100%"
      />
    );
  };

  const removeFilter = (e,filterType) => {
    e.preventDefault();
    switch (filterType) {
      case "status":
        ET_UPDATE_Bulk_REFRESH({ status: "any" });
        break;
      case "domain":
        ET_UPDATE_Bulk_REFRESH({ domain: null });
        break;
      case "assignedTo":
        ET_UPDATE_Bulk_REFRESH({ assignedTo: null });
        break;
      case "from":
        ET_UPDATE_Bulk_REFRESH({ from: "" });
        break;
      default:
        break;
    }
  }
  const filter = () => {
    return (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        {emailState.status !== 'any' &&<div>
          <Tag
            closeIcon={<CloseCircleOutlined onClick={(e) => removeFilter(e,'status')} />}
            style={{
              fontSize: "12px",
              fontWeight: "normal",
              background: "#FFFFFF",
            }}
          >
            {emailState.status}
          </Tag>
        </div>}
        {emailState.domain !== '' && emailState.domain !== null &&<div>
          <Tag
            closeIcon={<CloseCircleOutlined onClick={(e) => removeFilter(e,'domain')} />}
            style={{
              fontSize: "12px",
              fontWeight: "normal",
              background: "#FFFFFF",
            }}
          >
            {emailState.domain}
          </Tag>
        </div>}
        {emailState.assignedTo !== '' && emailState.assignedTo !== null &&<div>
          <Tag
            closeIcon={<CloseCircleOutlined onClick={(e) => removeFilter(e,'assignedTo')} />}
            style={{
              fontSize: "12px",
              fontWeight: "normal",
              background: "#FFFFFF",
            }}
          >
            {emailState.assignedTo.split('&')[0]}
          </Tag>
        </div>}
        {emailState.from !== '' && emailState.from !== null && <div>
          <Tag
            closeIcon={<CloseCircleOutlined onClick={(e) => removeFilter(e,'from')} />}
            style={{
              fontSize: "12px",
              fontWeight: "normal",
              background: "#FFFFFF",
            }}
          >
            {emailState.from}
          </Tag>
        </div>}
      </div>
    );
  };
  const sort = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          {selectedRowKeys.length > 0 && (
            <>
              <TooltipComp title="Mark as unread">
                <i
                  onClick={() => toggleReadUnread2()}
                  style={{ fontSize: "17px", color: "#5c667b" }}
                  className="fa fa-envelope"
                ></i>
              </TooltipComp>
              &nbsp;&nbsp;&nbsp;
              <TooltipComp title="Mark as read">
                <i
                  onClick={() => toggleReadUnread()}
                  style={{ fontSize: "17px", color: "#5c667b" }}
                  className="fa fa-envelope-open"
                ></i>
              </TooltipComp>
              &nbsp;&nbsp;&nbsp;
            </>
          )}
          {emailState.sort === "asc" ? (
            <TooltipComp title={"Oldest first"}>
              <i
                className="fa fa-sort-amount-asc"
                onClick={() => onChangeSort()}
                style={{ fontSize: "17px", color: "#5c667b" }}
              ></i>
            </TooltipComp>
          ) : (
            <TooltipComp title={"Latest first"}>
              <i
                onClick={() => onChangeSort()}
                style={{ fontSize: "17px", color: "#5c667b" }}
                className="fa fa-sort-amount-desc"
              ></i>
            </TooltipComp>
          )}
          &nbsp;&nbsp;&nbsp;
          <TooltipComp title={"Refresh"}>
            <SyncOutlined
              style={{ fontSize: "20px", color: "#5c667b" }}
              onClick={() => onChangeRefresh()}
            />
          </TooltipComp>
          &nbsp;&nbsp;&nbsp;
          <TooltipComp title={"Filter"}>
            <FilterListIcon
              style={{ fontSize: "26px", color: "#5c667b" }}
              onClick={() => setIsOpen(true)}
            />
          </TooltipComp>
        </div>
      </>
    );
  };
  const columns = [
    {
      title: tabSearch(),
      dataIndex: "name",
      render: (_, text) => (
        <>
          <span
            style={{
              color: "#5c667b",
              alignItems: "center",
              fontSize: "16px",
              fontWeight: "200",
            }}
          >
            {!text.unRead ? (
              <i
                className="fa fa-envelope-open"
                style={{ color: "#5c667b" }}
              ></i>
            ) : (
              <i style={{ color: "#5c667b" }} className="fa fa-envelope"></i>
            )}
            &nbsp;{text.emailFrom.split("<")[0]}
            {text.conversationCount > 1 && (
              <span style={{ color: "#5c667b" }}>
                ({text.conversationCount})
              </span>
            )}
          </span>
          <div>
            {text.ticketCategory && (
              <Tag color={"#f1aa45"}>{text.ticketCategory}</Tag>
            )}
          </div>
        </>
      ),
      // width: "20%",
    },
    {
      title: filter(),
      dataIndex: "age",
      render: (_, text) => (
        <>
          <div
            onClick={() =>
              navigate(`/emailHome/emailticketdetails/${text.ticketId}`)
            }
            className="recordlink"
            style={{ fontWeight: `${text.unRead ? "300" : "200"}` }}
          >
            {text.ticketId}-{text.ticketSubject}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              {text.ticketStatus === "Open" && (
                <Tag color={"#428bca"}>Open</Tag>
              )}
              {text.ticketStatus === "Closed" && (
                <Tag color={"#5d995d"}>Closed</Tag>
              )}
            </div>
            <div>
              {text.newAvailableAnswers && (
                <span
                  style={{
                    color: "#5d995c",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "21px",
                  }}
                >
                  1 new Answer available!
                </span>
              )}
            </div>
          </div>
        </>
      ),
      width: "60%",
    },
    {
      title: sort(),
      dataIndex: "address",
      render: (_, text) => (
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              color: "#5c667b",
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: "200",
              justifyContent: "center",
            }}
          >
            {moment(text.createdDate).format("MMM DD, YYYY")}
          </div>
          {!text.ticketCategory && (
            <div style={{ justifyContent: "center", display: "flex" }}>
              <Tag color={"#ee792a"}>Expert Request</Tag>
            </div>
          )}
          {text.expertFirstName && (
            <div
              style={{ color: "#5c667b", fontSize: "12px", fontWeight: "200" }}
            >
              <div>Assigned to:</div>
              <div style={{ fontWeight: "400" }}>
                {text.expertFirstName} {text.expertLastName}
              </div>
            </div>
          )}
        </div>
      ),
      // width: "20%",
      // align: "left",
    },
  ];
  const onSelectChange = (asd) => {
    setSelectedRowKeys(asd);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <>
      <Spin
        spinning={emailState.isLoading}
        size="large"
        style={{ width: "100%" }}
      >
        <Table
          rowSelection={rowSelection}
          columns={columns}
          rowClassName={(record, index) =>
            record.unRead ? "table-row-light" : "table-row-dark"
          }
          dataSource={emailState.data}
          pagination={false}
          style={{ marginBlock: "10px" }}
          rowKey={(record) => record.ticketId}
        />
      </Spin>
      {!emailState.isLoading && (
        <div
          style={{
            marginBlock: "10px",
            display: "flex",
            justifyContent: "right",
            color: "#5c667b",
          }}
        >
          <Pagination
            style={{ color: "#5c667b" }}
            total={emailState.count}
            current={emailState.pageNo + 1}
            onChange={(e) => onChangePage(e - 1)}
            showSizeChanger={false}
            pageSize={20}
          />
        </div>
      )}
      <Drawer
        title="Filter"
        placement="right"
        onClose={() => setIsOpen(false)}
        open={isOpen}
        width={"35%"}
      >
        <ExtraFilters
          handleCancel={() => setIsOpen(false)}
          isOpen={isOpen}
          bulkUpdate={ET_UPDATE_Bulk_REFRESH}
        />
      </Drawer>
    </>
  );
}
